const NES_MESSAGE_TRANSLATIONS = {
  nl: {
    success: "Succes",
    informative: "Informatief",
    warning: "Waarschuwing",
    error: "Error",
    "error-heavy": "Error",
    close: "Sluit bericht",
  },
  en: {
    success: "Success",
    informative: "Informative",
    warning: "Warning",
    error: "Error",
    "error-heavy": "Error",
    close: "Close message",
  },
};

const NES_TYPE_TO_ICON_NAME = {
  success: "check",
  informative: "info",
  warning: "alert",
  error: "alert",
  "error-heavy": "alert",
};
const NES_TYPE_TO_ICON_COLOR = {
  success: "text-success-contrast",
  informative: "text-info",
  warning: "text-warning-contrast",
  error: "text-alert",
  "error-heavy": "text-light",
};

export { NES_MESSAGE_TRANSLATIONS as N, NES_TYPE_TO_ICON_NAME as a, NES_TYPE_TO_ICON_COLOR as b };
